<template>
  <div
    :class="[
      'header-area bg-white dark:bg-[#0c1427] py-[13px] px-[20px] md:px-[25px] fixed top-0 z-[6] transition-all shadow-md dark:shadow-xl pointer-events-auto',
      { active: stateStoreInstance?.open },
    ]"
  >
    <div class="flex items-center justify-between pointer-events-auto">
      <div class="flex items-center pointer-events-auto">
        <div
          class="relative leading-none top-px pointer-events-auto"
        >
          <button
            type="button"
            class="hide-sidebar-toggle transition-all inline-block hover:text-primary-500 pointer-events-auto top-menu-item"
            @click="stateStoreInstance?.onChange"
          >
            <i class="material-symbols-outlined !text-[20px]"> menu </i>
          </button>
        </div>
      </div>
      <div
        class="flex items-center pointer-events-auto"
      >
        <div
          class="relative mx-[4px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
        >
          <DarkSwtichBtn />
        </div>
        <LanguageMenu />
        <div
          class="relative mx-[4px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0 hidden md:block"
        >
          <ToggleFullscreenBtn />
        </div>

        <NotificationsLists />

        <AdminProfile />

        <div
          class="relative settings-menu mx-[4px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
        >
          <SettingsBtn />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed, onBeforeUnmount } from "vue";
import stateStore from "@/utils/store";
import { useI18n } from "vue-i18n";
import emitter from "@/utils/emitter";

import DarkSwtichBtn from "./DarkSwtichBtn.vue";
import LanguageMenu from "./LanguageMenu.vue";
import ToggleFullscreenBtn from "./ToggleFullscreenBtn.vue";
import NotificationsLists from "./NotificationsLists.vue";
import AdminProfile from "./AdminProfile.vue";
import SettingsBtn from "./SettingsBtn.vue";

export default defineComponent({
  name: "TopHeader",
  components: {
    DarkSwtichBtn,
    LanguageMenu,
    ToggleFullscreenBtn,
    NotificationsLists,
    AdminProfile,
    SettingsBtn,
  },
  setup() {
    const stateStoreInstance = stateStore;
    const { locale, messages } = useI18n();
    const isSticky = ref(false);
    const showDebug = ref(false);
    
    // Extract the translations for the current locale
    const translations = computed(() => {
      const currentMessages = messages.value[locale.value];
      return currentMessages || null;
    });
    
    const debugReload = () => {
      localStorage.setItem('reload_translations', 'true');
      window.location.reload();
    };
    
    // Handle when app becomes active after being in background
    const handleAppBecameActive = () => {
      console.log('TopHeader: App became active, refreshing state');
      // Touch the stateStore to ensure reactivity
      if (stateStoreInstance) {
        // Fix the TypeScript error - can't test void for truthiness
        if (typeof stateStoreInstance.refresh === 'function') {
          stateStoreInstance.refresh();
        } else {
          console.log('No refresh method available');
        }
      }
    };

    onMounted(() => {
      window.addEventListener("scroll", () => {
        let scrollPos = window.scrollY;
        isSticky.value = scrollPos >= 100;
      });
      
      // Listen for app becoming active event
      emitter.on('app:active', handleAppBecameActive);
    });
    
    onBeforeUnmount(() => {
      // Remove emitter listener
      emitter.off('app:active', handleAppBecameActive);
    });

    return {
      isSticky,
      stateStoreInstance,
      locale,
      translations,
      showDebug,
      debugReload
    };
  },
});
</script>
